import { createContext, useContext } from 'react'

import { isNil } from 'ramda'

export type API = {
  variant: 'head' | 'body'
}

const TableSectionContext = createContext<null | API>(null)

const TableSectionProvider = TableSectionContext.Provider

const variantToComponentRootMap = {
  head: 'th',
  body: 'td',
} as const

type HookProps = {
  component?: (typeof variantToComponentRootMap)[keyof typeof variantToComponentRootMap]
}

const useTableSection = ({ component }: HookProps) => {
  const context = useContext(TableSectionContext)

  if (isNil(context)) {
    throw new Error(`useTableSection must be used within a CountProvider`)
  }

  const Component = component ?? variantToComponentRootMap[context.variant]

  return {
    context,
    Component,
  }
}

export { useTableSection, TableSectionProvider }
